import { useEffect } from 'react';
import api from '../services/api';

// Registra (uma vez por montagem) o acesso a uma atividade, para alimentar
// o ranking de "atividades mais acessadas" no dashboard de administração.
export default function useLogActivityAccess(activityKey) {
  useEffect(() => {
    api.post('/user/activity-access', { activity_key: activityKey }).catch(() => {});
  }, [activityKey]);
}
